<div mat-dialog-title
     class="title">
    <div class="subtitle">{{ formTitle | translate }}</div>
    <button mat-icon-button
            mat-dialog-close
            tabindex="-1"
            [matTooltip]="'Close' | translate"
            class="close-button hidden">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div>
    <mat-dialog-content>
        <div class="line line-margin">
            <mat-form-field color="primary">
                <mat-select placeholder="{{ 'Coach_Attribution' | translate }}"
                            [formControl]="coachSelectFormControl"
                            multiple
                            #multiSelect>
                  <mat-option>
                    <ngx-mat-select-search
                      [placeholderLabel]="'Search' | translate"
                      [noEntriesFoundLabel]="'No_Entries_Found' | translate"
                      [formControl]="coachFilterFormControl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let coach of filteredCoaches | async" [value]="coach">
                    {{ coach.firstName + ' ' + coach.lastName }}
                  </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button
                mat-dialog-close
                tabindex="-1">
            {{ 'Cancel' | translate}}
        </button>
        <button mat-raised-button
                (click)="onSaveClicked()"
                color="accent">
            {{ confirmButtonTitle | translate}}
        </button>
    </mat-dialog-actions>
</div>

<div class="progress-container">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
